<template>
    <div>
        <div v-if="restrictionGroups.length">
            <section class="section" v-for="(group, index) in restrictionGroups" :key="index">
                <div class="section-heading">
                    {{ group.name }}
                </div>
                <div class="section-row" v-for="item in group.items" :key="item.id">
                    <div class="section-row__col section-row__col--one-half">
                        <div>
                            <div class="label">
                                {{ item.type.label }}
                            </div>

                            <div class="value">
                                {{ item.restriction.label }}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <section class="section" v-else>
            <div class="section-row">
                <alert type="info">
                    {{ trans('vuetables.label.noResults') }}
                </alert>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        'user': {
            type: Object,
            default: false
        },
        'restrictions': {
            type: Array,
            default: false
        },
    },

    data() {
        return {
            restrictionGroups: this.restrictions.length ? this.restrictions : [],
        };
    },

    methods: {
        getRestrictions() {
            axios.get(this.route('tenantapi.users.reporting_restrictions.get', {'user': this.user.id}))
                .then((response) => {
                    this.restrictionGroups = response.data.data;
                })
                .catch(() => {
                });
        },
    },
};
</script>
